import React from "react";
import styled from "styled-components";
import borrowerImg from "../../images/borrower_img.png";
import borrowerMobileImg from "../../images/borrower_img_mobile.png";
import infoImg from "../../images/info.svg";

const StyledWrapper = styled.section`
  background-color: #ffffff;
  padding: 3rem 0 0;
  font-family: Inter;
  color: #000000;

  @media (min-width: 1440px) {
    max-width: 1440px;
    margin: 0 auto;
  }
  .wrapper {
    display: flex;
    align-items: center;
    width: 100%;
    @media (max-width: 768px) {
      flex-direction: column-reverse;
    }
  }

  .left {
    width: 68.75vw;
    padding: 0 9vw 0 5.5vw;
    @media (max-width: 768px) {
      width: 100vw;
      padding: 30px 16px;
    }
  }

  .gray-message {
    width: 32vw;
    border-radius: 3.4vw;
    background-color: #e3e5e5;
    font-size: 2.5vw;
    font-weight: 700;
    line-height: 3.125vw;
    letter-spacing: -0.02em;
    text-align: left;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 1.67vw 2.64vw;
    @media (max-width: 768px) {
      width: 80vw;
      font-size: 28px;
      line-height: 36px;
      letter-spacing: 0em;
      border-radius: 36px;
      padding: 16px 9px 15px 26px;
    }
  }

  .orange-message {
    width: 35vw;
    border-radius: 3.4vw;
    background-color: #ff8f60;
    font-size: 2.5vw;
    font-weight: 600;
    line-height: 3.125vw;
    letter-spacing: -0.025em;
    text-align: left;
    color: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 21px;
    padding: 1.67vw 3.26vw;
    @media (max-width: 768px) {
      width: 80vw;
      font-size: 28px;
      line-height: 36px;
      letter-spacing: 0em;
      border-radius: 36px;
      padding: 14px 18px 14px 30px;
    }
  }

  .borrower-img {
    border-radius: 61px;
    margin: 0 10px;
    width: 295px;
    height: 295px;
    @media (max-width: 768px) {
      display: none;
    }
  }

  .borrower-mobile-img {
    display: none;
    @media (max-width: 768px) {
      display: block;
      padding: 0px;
      height: auto;
      width: 90vw;
    }
  }

  .pre-approved {
    display: flex;
    justify-content: space-between;
    align-items: center;
    text-align: center;
    margin: 119px auto 120px;
    width: 32vw;

    font-size: 1.944vw;
    font-weight: 400;
    letter-spacing: -0.02em;
    text-align: left;

    @media (max-width: 768px) {
      margin: 82px auto 107px;
      width: 75vw;
      flex-direction: column;

      font-size: 24px;
      font-weight: 400;
      line-height: 32px;
      letter-spacing: 0em;
      text-align: center;
    }
  }

  .info-icon {
    width: 2.3vw;
    height: 2.3vw;
    margin-right: 2vw;
    @media (max-width: 768px) {
      width: 36px;
      height: 36px;
      margin-right: 0px;
      margin-bottom: 11.33px;
    }
  }
`;

const Message = () => {
  return (
    <StyledWrapper>
      <div className="wrapper">
        <div className="left">
          <div className="gray-message">
            Have a personal loan offer from Niro?
          </div>
          <div className="d-flex align-items-center justify-content-end">
            <div className="orange-message">
              Congrats! We will make sure you get the money.
            </div>
          </div>
        </div>
        <div>
          <img src={borrowerMobileImg} alt="" className="borrower-mobile-img" />
          <img src={borrowerImg} alt="" className="borrower-img" />
        </div>
      </div>
      <div className="pre-approved">
        <img src={infoImg} alt="" className="info-icon" />
        <div>Please don't apply without a pre-approved offer from us.</div>
      </div>
    </StyledWrapper>
  );
};

export default Message;
